import { PageId } from 'src/constants/routing.constant';
import { useNavigate } from 'src/hooks/useNavigate';
import { getLastInboxBoard } from 'src/reactives/lastView.reactive';

export const useGetInboxDefaultUrl = () => {
  const { getUrl } = useNavigate();
  const { boardSlug } = getLastInboxBoard();
  return () => getUrl(PageId.InboxView, { boardSlug });
};
